import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  label = input<string>('Botão');
  isLink = input<boolean>(true);
  route = input<string | any[]>('/');
  type = input<'button' | 'submit' | 'reset'>('button');
  hasIcon = input<boolean>(false);
  fullWidth = input<boolean>(false);
  size = input<string>('');
  mode = input<string>('');
  disabled = input<boolean>(false);
}
